import { ValidationResultFail } from '@inter-ikea-core/core';
import { ValidationBase } from '@inter-ikea-core/core-toolbox';
export class PlannerValidation extends ValidationBase {
    constructor(coreApi, id) {
        super();
        this.coreApi = coreApi;
        this.id = id;
        Object.assign(this.coreApi.validations, { [id]: this });
    }
    validationOK() {
        return null;
    }
    validationFail(message) {
        return new ValidationResultFail(message, '');
    }
}
//# sourceMappingURL=PlannerValidation.js.map